var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.loading
        ? _c(
            "v-container",
            {
              attrs: {
                fluid: ""
              }
            },
            [
              _c(
                "v-card",
                {
                  staticClass: "app-card"
                },
                [
                  _c(
                    "v-card-text",
                    {
                      staticClass: "pa-4"
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "ma-auto text-center",
                              attrs: {
                                cols: "12"
                              }
                            },
                            [
                              _c("v-progress-circular", {
                                attrs: {
                                  loading: _vm.loading,
                                  indeterminate: "",
                                  color: "primary",
                                  size: "64",
                                  width: "2"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "div",
            [
              _c("basic-choice"),
              _vm.newSiteSelected ? _c("new-website") : _vm._e(),
              _vm.displayAltWebsite ? _c("new-website-alt") : _vm._e(),
              _vm.migrateSelected ? _c("migrate-website") : _vm._e(),
              _vm.skipThisSelected ? _c("skip-this") : _vm._e(),
              _vm.starterSiteSelected ? _c("starter-site") : _vm._e(),
              _c(
                "v-row",
                [
                  _vm.showButtons.next
                    ? _c(
                        "v-col",
                        {
                          staticClass: "text-center",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                color: "primary",
                                elevation: "0",
                                tile: ""
                              },
                              on: {
                                click: _vm.nextStep
                              }
                            },
                            [_vm._v(" Continue ")]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }